import MicroModal from "micromodal";

const click = (e) => {
  const content = e.target.querySelector(".modal-content").innerHTML;
  document.querySelector(".modal__content").innerHTML = content;
  setTimeout(() => {
    document.querySelector(".modal__container").scrollTop = 0;
  }, 200);
};

document.querySelectorAll(".card").forEach((card) => {
  card.addEventListener("click", click);
});

MicroModal.init();

document.body.classList.add("rapport-annuel");
